import { render, staticRenderFns } from "./loadAssessmentPop.vue?vue&type=template&id=07c27964"
import script from "./loadAssessmentPop.vue?vue&type=script&lang=js"
export * from "./loadAssessmentPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07c27964')) {
      api.createRecord('07c27964', component.options)
    } else {
      api.reload('07c27964', component.options)
    }
    module.hot.accept("./loadAssessmentPop.vue?vue&type=template&id=07c27964", function () {
      api.rerender('07c27964', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/loadAssessmentPop.vue"
export default component.exports